import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#283570",
      d: "M9.192 3.25v-1.5h5.616v1.5zm2.058 11.058h1.5V8.692h-1.5zM12 22q-1.755 0-3.3-.67a8.6 8.6 0 0 1-2.704-1.826A8.6 8.6 0 0 1 4.17 16.8a8.2 8.2 0 0 1-.669-3.3q0-1.755.67-3.3a8.6 8.6 0 0 1 1.826-2.704A8.6 8.6 0 0 1 8.7 5.67 8.2 8.2 0 0 1 12 5q1.502 0 2.893.51 1.392.51 2.584 1.46l1.246-1.247 1.054 1.054-1.246 1.246a9.2 9.2 0 0 1 1.46 2.584q.51 1.391.509 2.893 0 1.755-.67 3.3a8.6 8.6 0 0 1-1.826 2.704A8.6 8.6 0 0 1 15.3 21.33Q13.755 22 12 22m0-1.5q2.9 0 4.95-2.05T19 13.5t-2.05-4.95T12 6.5 7.05 8.55 5 13.5t2.05 4.95T12 20.5"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "timer"}) } }